import React, { useEffect, useState } from 'react';
import { StatisticsBlock } from './StatisticsBlock';
import { StatisticsTab } from './StatisticsTab';
import { homeService } from '../../services/homeService';
import { MedicHomeStatisticsDto } from '../../models/home/medicHomeStatisticsDto';
import { ROUTES } from '../../constants/routes';
import { useNavigate } from 'react-router-dom';
import TmClipboardList from '../../icons/TmClipboardList';
import TmBuilding from '../../icons/TmBuilding';
import TmBookOpen from '../../icons/TmBookOpen';
import TmBreathalyzer from '../../icons/TmBreathalyzer';
import { Box, Typography } from '@mui/material';
import ErrorAlert from '../common/ErrorAlert';
import { AlcoholCheckupsModal } from './AlcoholCheckupsModal';
import { DateUtils } from '../../helpers/dateUtils';
import { WorkplaceSigningStatus } from '../medics/WorkplaceSigningStatus';

export const MedicHome: React.FC = () => {
    const navigate = useNavigate();
    const [statistics, setStatistics] = useState<MedicHomeStatisticsDto | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);
    const [alcoholModalOpen, setAlcoholModalOpen] = useState(false);

    useEffect(() => {
        loadStatistics();
    }, []);

    const loadStatistics = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await homeService.getMedicStatistics();
            setStatistics(response.data.data);
        } catch (e: any) {
            setError(e.message ?? 'Ошибка загрузки статистики');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box>
            {error && <ErrorAlert message={error} onClose={() => setError(null)} />}

            {statistics?.medicInfo.medicalOrganizationName && (
                <Typography variant="body2" sx={{ mb: 0.5, color: '#2A2932' }}>
                    Медицинская организация: {statistics.medicInfo.medicalOrganizationName}
                </Typography>
            )}

            {statistics?.medicInfo.digitalSignExpiredAt && (
                <Typography variant="body2" sx={{ mb: 2, color: '#2A2932' }}>
                    Срок действия ЭЦП: {DateUtils.formatDate(statistics.medicInfo.digitalSignExpiredAt)}
                </Typography>
            )}

            <Box sx={{ mb: 4 }}>
                <WorkplaceSigningStatus />
            </Box>

            <StatisticsBlock title="Общая статистика">
                <StatisticsTab
                    icon={<TmClipboardList />}
                    label="Осмотры в этом месяце"
                    value={statistics?.generalStatistics.medicalcheckupsCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.medicalCheckups.history)}
                />
                <StatisticsTab
                    icon={<TmBuilding />}
                    label="Компании"
                    value={statistics?.generalStatistics.companiesCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.clients.list)}
                />
                <StatisticsTab
                    icon={<TmBookOpen />}
                    label="Журналы на подпись"
                    value={statistics?.generalStatistics.journalsForSignCount ?? null}
                    loading={loading}
                    onClick={() => navigate(ROUTES.medicalCheckups.journal)}
                />
                <StatisticsTab
                    icon={<TmBreathalyzer />}
                    label="Алкоголь"
                    value={statistics?.generalStatistics.alcoholCount ?? null}
                    loading={loading}
                    onClick={() => setAlcoholModalOpen(true)}
                />
            </StatisticsBlock>

            <AlcoholCheckupsModal
                open={alcoholModalOpen}
                onClose={() => setAlcoholModalOpen(false)}
            />
        </Box>
    );
};

